/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as BoardRouteImport } from './routes/_board'
import { Route as AuthenticatedGlobalRouteImport } from './routes/_authenticated._global'
import { Route as AuthenticatedOrganizationRouteImport } from './routes/_authenticated._organization'
import { Route as AuthenticatedProjectsRouteImport } from './routes/_authenticated._projects'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/_auth/forgot-password/index'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/_auth/reset-password/index'
import { Route as AuthSignInIndexRouteImport } from './routes/_auth/sign-in/index'
import { Route as AuthSignUpIndexRouteImport } from './routes/_auth/sign-up/index'
import { Route as AuthVerifyEmailIndexRouteImport } from './routes/_auth/verify-email/index'
import { Route as BoardBoardBoardIdRouteImport } from './routes/_board/board/$boardId'
import { Route as AuthenticatedGlobalFeatureRequestIndexRouteImport } from './routes/_authenticated/_global/feature-request/index'
import { Route as AuthenticatedGlobalMembersIndexRouteImport } from './routes/_authenticated/_global/members/index'
import { Route as AuthenticatedGlobalPricingIndexRouteImport } from './routes/_authenticated/_global/pricing/index'
import { Route as AuthenticatedGlobalPricingCanceledRouteImport } from './routes/_authenticated/_global/pricing/canceled'
import { Route as AuthenticatedGlobalPricingSuccessRouteImport } from './routes/_authenticated/_global/pricing/success'
import { Route as AuthenticatedGlobalProjectsIndexRouteImport } from './routes/_authenticated/_global/projects/index'
import { Route as AuthenticatedGlobalRoadmapIndexRouteImport } from './routes/_authenticated/_global/roadmap/index'
import { Route as AuthenticatedGlobalUserSettingsIndexRouteImport } from './routes/_authenticated/_global/user-settings/index'
import { Route as AuthenticatedOrganizationOrganizationCreateRouteImport } from './routes/_authenticated/_organization/organization/create'
import { Route as AuthenticatedOrganizationOrganizationSelectRouteImport } from './routes/_authenticated/_organization/organization/select'
import { Route as AuthenticatedProjectsProjectsProjectIdRouteRouteImport } from './routes/_authenticated/_projects/projects/$projectId/route'
import { Route as AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRouteImport } from './routes/_authenticated/_organization/organization/accept-invitation/$invitationId'
import { Route as AuthenticatedProjectsProjectsProjectIdRequestsIndexRouteImport } from './routes/_authenticated/_projects/projects/$projectId/requests/index'
import { Route as AuthenticatedProjectsProjectsProjectIdStatsIndexRouteImport } from './routes/_authenticated/_projects/projects/$projectId/stats/index'
import { Route as AuthenticatedProjectsProjectsProjectIdUsersIndexRouteImport } from './routes/_authenticated/_projects/projects/$projectId/users/index'

const BoardBoardIndexLazyRouteImport = createFileRoute('/_board/board/')()
const AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRouteImport =
  createFileRoute('/_authenticated/_projects/projects/$projectId/settings/')()
const AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/_projects/projects/$projectId/users/$userId/',
  )()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardRoute = BoardRouteImport.update({
  id: '/_board',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedGlobalRoute = AuthenticatedGlobalRouteImport.update({
  id: '/_global',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationRoute =
  AuthenticatedOrganizationRouteImport.update({
    id: '/_organization',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsRoute = AuthenticatedProjectsRouteImport.update({
  id: '/_projects',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInIndexRoute = AuthSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpIndexRoute = AuthSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailIndexRoute = AuthVerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => AuthRoute,
} as any)
const BoardBoardIndexLazyRoute = BoardBoardIndexLazyRouteImport.update({
  id: '/board/',
  path: '/board/',
  getParentRoute: () => BoardRoute,
} as any).lazy(() =>
  import('./routes/_board/board/index.lazy').then((d) => d.Route),
)
const BoardBoardBoardIdRoute = BoardBoardBoardIdRouteImport.update({
  id: '/board/$boardId',
  path: '/board/$boardId',
  getParentRoute: () => BoardRoute,
} as any)
const AuthenticatedGlobalFeatureRequestIndexRoute =
  AuthenticatedGlobalFeatureRequestIndexRouteImport.update({
    id: '/feature-request/',
    path: '/feature-request/',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalMembersIndexRoute =
  AuthenticatedGlobalMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalPricingIndexRoute =
  AuthenticatedGlobalPricingIndexRouteImport.update({
    id: '/pricing/',
    path: '/pricing/',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalPricingCanceledRoute =
  AuthenticatedGlobalPricingCanceledRouteImport.update({
    id: '/pricing/canceled',
    path: '/pricing/canceled',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalPricingSuccessRoute =
  AuthenticatedGlobalPricingSuccessRouteImport.update({
    id: '/pricing/success',
    path: '/pricing/success',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalProjectsIndexRoute =
  AuthenticatedGlobalProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalRoadmapIndexRoute =
  AuthenticatedGlobalRoadmapIndexRouteImport.update({
    id: '/roadmap/',
    path: '/roadmap/',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedGlobalUserSettingsIndexRoute =
  AuthenticatedGlobalUserSettingsIndexRouteImport.update({
    id: '/user-settings/',
    path: '/user-settings/',
    getParentRoute: () => AuthenticatedGlobalRoute,
  } as any)
const AuthenticatedOrganizationOrganizationCreateRoute =
  AuthenticatedOrganizationOrganizationCreateRouteImport.update({
    id: '/organization/create',
    path: '/organization/create',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedOrganizationOrganizationSelectRoute =
  AuthenticatedOrganizationOrganizationSelectRouteImport.update({
    id: '/organization/select',
    path: '/organization/select',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)
const AuthenticatedProjectsProjectsProjectIdRouteRoute =
  AuthenticatedProjectsProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedProjectsRoute,
  } as any)
const AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute =
  AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRouteImport.update(
    {
      id: '/organization/accept-invitation/$invitationId',
      path: '/organization/accept-invitation/$invitationId',
      getParentRoute: () => AuthenticatedOrganizationRoute,
    } as any,
  )
const AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute =
  AuthenticatedProjectsProjectsProjectIdRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AuthenticatedProjectsProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute =
  AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedProjectsProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_projects/projects/$projectId/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedProjectsProjectsProjectIdStatsIndexRoute =
  AuthenticatedProjectsProjectsProjectIdStatsIndexRouteImport.update({
    id: '/stats/',
    path: '/stats/',
    getParentRoute: () => AuthenticatedProjectsProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_projects/projects/$projectId/stats/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedProjectsProjectsProjectIdUsersIndexRoute =
  AuthenticatedProjectsProjectsProjectIdUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedProjectsProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute =
  AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRouteImport.update({
    id: '/users/$userId/',
    path: '/users/$userId/',
    getParentRoute: () => AuthenticatedProjectsProjectsProjectIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/_projects/projects/$projectId/users/$userId/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/board/$boardId': typeof BoardBoardBoardIdRoute
  '/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/reset-password/': typeof AuthResetPasswordIndexRoute
  '/sign-in/': typeof AuthSignInIndexRoute
  '/sign-up/': typeof AuthSignUpIndexRoute
  '/verify-email/': typeof AuthVerifyEmailIndexRoute
  '/board/': typeof BoardBoardIndexLazyRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectsProjectIdRouteRouteWithChildren
  '/pricing/canceled': typeof AuthenticatedGlobalPricingCanceledRoute
  '/pricing/success': typeof AuthenticatedGlobalPricingSuccessRoute
  '/organization/create': typeof AuthenticatedOrganizationOrganizationCreateRoute
  '/organization/select': typeof AuthenticatedOrganizationOrganizationSelectRoute
  '/feature-request/': typeof AuthenticatedGlobalFeatureRequestIndexRoute
  '/members/': typeof AuthenticatedGlobalMembersIndexRoute
  '/pricing/': typeof AuthenticatedGlobalPricingIndexRoute
  '/projects/': typeof AuthenticatedGlobalProjectsIndexRoute
  '/roadmap/': typeof AuthenticatedGlobalRoadmapIndexRoute
  '/user-settings/': typeof AuthenticatedGlobalUserSettingsIndexRoute
  '/organization/accept-invitation/$invitationId': typeof AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute
  '/projects/$projectId/requests/': typeof AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute
  '/projects/$projectId/stats/': typeof AuthenticatedProjectsProjectsProjectIdStatsIndexRoute
  '/projects/$projectId/users/': typeof AuthenticatedProjectsProjectsProjectIdUsersIndexRoute
  '/projects/$projectId/settings/': typeof AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute
  '/projects/$projectId/users/$userId/': typeof AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/board/$boardId': typeof BoardBoardBoardIdRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/reset-password': typeof AuthResetPasswordIndexRoute
  '/sign-in': typeof AuthSignInIndexRoute
  '/sign-up': typeof AuthSignUpIndexRoute
  '/verify-email': typeof AuthVerifyEmailIndexRoute
  '/board': typeof BoardBoardIndexLazyRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectsProjectIdRouteRouteWithChildren
  '/pricing/canceled': typeof AuthenticatedGlobalPricingCanceledRoute
  '/pricing/success': typeof AuthenticatedGlobalPricingSuccessRoute
  '/organization/create': typeof AuthenticatedOrganizationOrganizationCreateRoute
  '/organization/select': typeof AuthenticatedOrganizationOrganizationSelectRoute
  '/feature-request': typeof AuthenticatedGlobalFeatureRequestIndexRoute
  '/members': typeof AuthenticatedGlobalMembersIndexRoute
  '/pricing': typeof AuthenticatedGlobalPricingIndexRoute
  '/projects': typeof AuthenticatedGlobalProjectsIndexRoute
  '/roadmap': typeof AuthenticatedGlobalRoadmapIndexRoute
  '/user-settings': typeof AuthenticatedGlobalUserSettingsIndexRoute
  '/organization/accept-invitation/$invitationId': typeof AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute
  '/projects/$projectId/requests': typeof AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute
  '/projects/$projectId/stats': typeof AuthenticatedProjectsProjectsProjectIdStatsIndexRoute
  '/projects/$projectId/users': typeof AuthenticatedProjectsProjectsProjectIdUsersIndexRoute
  '/projects/$projectId/settings': typeof AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute
  '/projects/$projectId/users/$userId': typeof AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_board': typeof BoardRouteWithChildren
  '/_authenticated/_global': typeof AuthenticatedGlobalRouteWithChildren
  '/_authenticated/_organization': typeof AuthenticatedOrganizationRouteWithChildren
  '/_authenticated/_projects': typeof AuthenticatedProjectsRouteWithChildren
  '/_board/board/$boardId': typeof BoardBoardBoardIdRoute
  '/_auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/_auth/reset-password/': typeof AuthResetPasswordIndexRoute
  '/_auth/sign-in/': typeof AuthSignInIndexRoute
  '/_auth/sign-up/': typeof AuthSignUpIndexRoute
  '/_auth/verify-email/': typeof AuthVerifyEmailIndexRoute
  '/_board/board/': typeof BoardBoardIndexLazyRoute
  '/_authenticated/_projects/projects/$projectId': typeof AuthenticatedProjectsProjectsProjectIdRouteRouteWithChildren
  '/_authenticated/_global/pricing/canceled': typeof AuthenticatedGlobalPricingCanceledRoute
  '/_authenticated/_global/pricing/success': typeof AuthenticatedGlobalPricingSuccessRoute
  '/_authenticated/_organization/organization/create': typeof AuthenticatedOrganizationOrganizationCreateRoute
  '/_authenticated/_organization/organization/select': typeof AuthenticatedOrganizationOrganizationSelectRoute
  '/_authenticated/_global/feature-request/': typeof AuthenticatedGlobalFeatureRequestIndexRoute
  '/_authenticated/_global/members/': typeof AuthenticatedGlobalMembersIndexRoute
  '/_authenticated/_global/pricing/': typeof AuthenticatedGlobalPricingIndexRoute
  '/_authenticated/_global/projects/': typeof AuthenticatedGlobalProjectsIndexRoute
  '/_authenticated/_global/roadmap/': typeof AuthenticatedGlobalRoadmapIndexRoute
  '/_authenticated/_global/user-settings/': typeof AuthenticatedGlobalUserSettingsIndexRoute
  '/_authenticated/_organization/organization/accept-invitation/$invitationId': typeof AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute
  '/_authenticated/_projects/projects/$projectId/requests/': typeof AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute
  '/_authenticated/_projects/projects/$projectId/stats/': typeof AuthenticatedProjectsProjectsProjectIdStatsIndexRoute
  '/_authenticated/_projects/projects/$projectId/users/': typeof AuthenticatedProjectsProjectsProjectIdUsersIndexRoute
  '/_authenticated/_projects/projects/$projectId/settings/': typeof AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute
  '/_authenticated/_projects/projects/$projectId/users/$userId/': typeof AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/board/$boardId'
    | '/forgot-password/'
    | '/reset-password/'
    | '/sign-in/'
    | '/sign-up/'
    | '/verify-email/'
    | '/board/'
    | '/projects/$projectId'
    | '/pricing/canceled'
    | '/pricing/success'
    | '/organization/create'
    | '/organization/select'
    | '/feature-request/'
    | '/members/'
    | '/pricing/'
    | '/projects/'
    | '/roadmap/'
    | '/user-settings/'
    | '/organization/accept-invitation/$invitationId'
    | '/projects/$projectId/requests/'
    | '/projects/$projectId/stats/'
    | '/projects/$projectId/users/'
    | '/projects/$projectId/settings/'
    | '/projects/$projectId/users/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/board/$boardId'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/board'
    | '/projects/$projectId'
    | '/pricing/canceled'
    | '/pricing/success'
    | '/organization/create'
    | '/organization/select'
    | '/feature-request'
    | '/members'
    | '/pricing'
    | '/projects'
    | '/roadmap'
    | '/user-settings'
    | '/organization/accept-invitation/$invitationId'
    | '/projects/$projectId/requests'
    | '/projects/$projectId/stats'
    | '/projects/$projectId/users'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/users/$userId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/_board'
    | '/_authenticated/_global'
    | '/_authenticated/_organization'
    | '/_authenticated/_projects'
    | '/_board/board/$boardId'
    | '/_auth/forgot-password/'
    | '/_auth/reset-password/'
    | '/_auth/sign-in/'
    | '/_auth/sign-up/'
    | '/_auth/verify-email/'
    | '/_board/board/'
    | '/_authenticated/_projects/projects/$projectId'
    | '/_authenticated/_global/pricing/canceled'
    | '/_authenticated/_global/pricing/success'
    | '/_authenticated/_organization/organization/create'
    | '/_authenticated/_organization/organization/select'
    | '/_authenticated/_global/feature-request/'
    | '/_authenticated/_global/members/'
    | '/_authenticated/_global/pricing/'
    | '/_authenticated/_global/projects/'
    | '/_authenticated/_global/roadmap/'
    | '/_authenticated/_global/user-settings/'
    | '/_authenticated/_organization/organization/accept-invitation/$invitationId'
    | '/_authenticated/_projects/projects/$projectId/requests/'
    | '/_authenticated/_projects/projects/$projectId/stats/'
    | '/_authenticated/_projects/projects/$projectId/users/'
    | '/_authenticated/_projects/projects/$projectId/settings/'
    | '/_authenticated/_projects/projects/$projectId/users/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  BoardRoute: typeof BoardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_board': {
      id: '/_board'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_global': {
      id: '/_authenticated/_global'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedGlobalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_organization': {
      id: '/_authenticated/_organization'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedOrganizationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_projects': {
      id: '/_authenticated/_projects'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedProjectsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/forgot-password/': {
      id: '/_auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password/': {
      id: '/_auth/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in/': {
      id: '/_auth/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof AuthSignInIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up/': {
      id: '/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof AuthSignUpIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-email/': {
      id: '/_auth/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email/'
      preLoaderRoute: typeof AuthVerifyEmailIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_board/board/': {
      id: '/_board/board/'
      path: '/board'
      fullPath: '/board/'
      preLoaderRoute: typeof BoardBoardIndexLazyRouteImport
      parentRoute: typeof BoardRoute
    }
    '/_board/board/$boardId': {
      id: '/_board/board/$boardId'
      path: '/board/$boardId'
      fullPath: '/board/$boardId'
      preLoaderRoute: typeof BoardBoardBoardIdRouteImport
      parentRoute: typeof BoardRoute
    }
    '/_authenticated/_global/feature-request/': {
      id: '/_authenticated/_global/feature-request/'
      path: '/feature-request'
      fullPath: '/feature-request/'
      preLoaderRoute: typeof AuthenticatedGlobalFeatureRequestIndexRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/members/': {
      id: '/_authenticated/_global/members/'
      path: '/members'
      fullPath: '/members/'
      preLoaderRoute: typeof AuthenticatedGlobalMembersIndexRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/pricing/': {
      id: '/_authenticated/_global/pricing/'
      path: '/pricing'
      fullPath: '/pricing/'
      preLoaderRoute: typeof AuthenticatedGlobalPricingIndexRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/pricing/canceled': {
      id: '/_authenticated/_global/pricing/canceled'
      path: '/pricing/canceled'
      fullPath: '/pricing/canceled'
      preLoaderRoute: typeof AuthenticatedGlobalPricingCanceledRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/pricing/success': {
      id: '/_authenticated/_global/pricing/success'
      path: '/pricing/success'
      fullPath: '/pricing/success'
      preLoaderRoute: typeof AuthenticatedGlobalPricingSuccessRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/projects/': {
      id: '/_authenticated/_global/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedGlobalProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/roadmap/': {
      id: '/_authenticated/_global/roadmap/'
      path: '/roadmap'
      fullPath: '/roadmap/'
      preLoaderRoute: typeof AuthenticatedGlobalRoadmapIndexRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_global/user-settings/': {
      id: '/_authenticated/_global/user-settings/'
      path: '/user-settings'
      fullPath: '/user-settings/'
      preLoaderRoute: typeof AuthenticatedGlobalUserSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedGlobalRoute
    }
    '/_authenticated/_organization/organization/create': {
      id: '/_authenticated/_organization/organization/create'
      path: '/organization/create'
      fullPath: '/organization/create'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationCreateRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_organization/organization/select': {
      id: '/_authenticated/_organization/organization/select'
      path: '/organization/select'
      fullPath: '/organization/select'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationSelectRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_projects/projects/$projectId': {
      id: '/_authenticated/_projects/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectsRoute
    }
    '/_authenticated/_organization/organization/accept-invitation/$invitationId': {
      id: '/_authenticated/_organization/organization/accept-invitation/$invitationId'
      path: '/organization/accept-invitation/$invitationId'
      fullPath: '/organization/accept-invitation/$invitationId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRoute
    }
    '/_authenticated/_projects/projects/$projectId/requests/': {
      id: '/_authenticated/_projects/projects/$projectId/requests/'
      path: '/requests'
      fullPath: '/projects/$projectId/requests/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectsProjectIdRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRoute
    }
    '/_authenticated/_projects/projects/$projectId/settings/': {
      id: '/_authenticated/_projects/projects/$projectId/settings/'
      path: '/settings'
      fullPath: '/projects/$projectId/settings/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRoute
    }
    '/_authenticated/_projects/projects/$projectId/stats/': {
      id: '/_authenticated/_projects/projects/$projectId/stats/'
      path: '/stats'
      fullPath: '/projects/$projectId/stats/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectsProjectIdStatsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRoute
    }
    '/_authenticated/_projects/projects/$projectId/users/': {
      id: '/_authenticated/_projects/projects/$projectId/users/'
      path: '/users'
      fullPath: '/projects/$projectId/users/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectsProjectIdUsersIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRoute
    }
    '/_authenticated/_projects/projects/$projectId/users/$userId/': {
      id: '/_authenticated/_projects/projects/$projectId/users/$userId/'
      path: '/users/$userId'
      fullPath: '/projects/$projectId/users/$userId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
  AuthVerifyEmailIndexRoute: typeof AuthVerifyEmailIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
  AuthVerifyEmailIndexRoute: AuthVerifyEmailIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedGlobalRouteChildren {
  AuthenticatedGlobalPricingCanceledRoute: typeof AuthenticatedGlobalPricingCanceledRoute
  AuthenticatedGlobalPricingSuccessRoute: typeof AuthenticatedGlobalPricingSuccessRoute
  AuthenticatedGlobalFeatureRequestIndexRoute: typeof AuthenticatedGlobalFeatureRequestIndexRoute
  AuthenticatedGlobalMembersIndexRoute: typeof AuthenticatedGlobalMembersIndexRoute
  AuthenticatedGlobalPricingIndexRoute: typeof AuthenticatedGlobalPricingIndexRoute
  AuthenticatedGlobalProjectsIndexRoute: typeof AuthenticatedGlobalProjectsIndexRoute
  AuthenticatedGlobalRoadmapIndexRoute: typeof AuthenticatedGlobalRoadmapIndexRoute
  AuthenticatedGlobalUserSettingsIndexRoute: typeof AuthenticatedGlobalUserSettingsIndexRoute
}

const AuthenticatedGlobalRouteChildren: AuthenticatedGlobalRouteChildren = {
  AuthenticatedGlobalPricingCanceledRoute:
    AuthenticatedGlobalPricingCanceledRoute,
  AuthenticatedGlobalPricingSuccessRoute:
    AuthenticatedGlobalPricingSuccessRoute,
  AuthenticatedGlobalFeatureRequestIndexRoute:
    AuthenticatedGlobalFeatureRequestIndexRoute,
  AuthenticatedGlobalMembersIndexRoute: AuthenticatedGlobalMembersIndexRoute,
  AuthenticatedGlobalPricingIndexRoute: AuthenticatedGlobalPricingIndexRoute,
  AuthenticatedGlobalProjectsIndexRoute: AuthenticatedGlobalProjectsIndexRoute,
  AuthenticatedGlobalRoadmapIndexRoute: AuthenticatedGlobalRoadmapIndexRoute,
  AuthenticatedGlobalUserSettingsIndexRoute:
    AuthenticatedGlobalUserSettingsIndexRoute,
}

const AuthenticatedGlobalRouteWithChildren =
  AuthenticatedGlobalRoute._addFileChildren(AuthenticatedGlobalRouteChildren)

interface AuthenticatedOrganizationRouteChildren {
  AuthenticatedOrganizationOrganizationCreateRoute: typeof AuthenticatedOrganizationOrganizationCreateRoute
  AuthenticatedOrganizationOrganizationSelectRoute: typeof AuthenticatedOrganizationOrganizationSelectRoute
  AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute: typeof AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute
}

const AuthenticatedOrganizationRouteChildren: AuthenticatedOrganizationRouteChildren =
  {
    AuthenticatedOrganizationOrganizationCreateRoute:
      AuthenticatedOrganizationOrganizationCreateRoute,
    AuthenticatedOrganizationOrganizationSelectRoute:
      AuthenticatedOrganizationOrganizationSelectRoute,
    AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute:
      AuthenticatedOrganizationOrganizationAcceptInvitationInvitationIdRoute,
  }

const AuthenticatedOrganizationRouteWithChildren =
  AuthenticatedOrganizationRoute._addFileChildren(
    AuthenticatedOrganizationRouteChildren,
  )

interface AuthenticatedProjectsProjectsProjectIdRouteRouteChildren {
  AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute: typeof AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute
  AuthenticatedProjectsProjectsProjectIdStatsIndexRoute: typeof AuthenticatedProjectsProjectsProjectIdStatsIndexRoute
  AuthenticatedProjectsProjectsProjectIdUsersIndexRoute: typeof AuthenticatedProjectsProjectsProjectIdUsersIndexRoute
  AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute: typeof AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute
  AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute: typeof AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute
}

const AuthenticatedProjectsProjectsProjectIdRouteRouteChildren: AuthenticatedProjectsProjectsProjectIdRouteRouteChildren =
  {
    AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute:
      AuthenticatedProjectsProjectsProjectIdRequestsIndexRoute,
    AuthenticatedProjectsProjectsProjectIdStatsIndexRoute:
      AuthenticatedProjectsProjectsProjectIdStatsIndexRoute,
    AuthenticatedProjectsProjectsProjectIdUsersIndexRoute:
      AuthenticatedProjectsProjectsProjectIdUsersIndexRoute,
    AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute:
      AuthenticatedProjectsProjectsProjectIdSettingsIndexLazyRoute,
    AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute:
      AuthenticatedProjectsProjectsProjectIdUsersUserIdIndexLazyRoute,
  }

const AuthenticatedProjectsProjectsProjectIdRouteRouteWithChildren =
  AuthenticatedProjectsProjectsProjectIdRouteRoute._addFileChildren(
    AuthenticatedProjectsProjectsProjectIdRouteRouteChildren,
  )

interface AuthenticatedProjectsRouteChildren {
  AuthenticatedProjectsProjectsProjectIdRouteRoute: typeof AuthenticatedProjectsProjectsProjectIdRouteRouteWithChildren
}

const AuthenticatedProjectsRouteChildren: AuthenticatedProjectsRouteChildren = {
  AuthenticatedProjectsProjectsProjectIdRouteRoute:
    AuthenticatedProjectsProjectsProjectIdRouteRouteWithChildren,
}

const AuthenticatedProjectsRouteWithChildren =
  AuthenticatedProjectsRoute._addFileChildren(
    AuthenticatedProjectsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedGlobalRoute: typeof AuthenticatedGlobalRouteWithChildren
  AuthenticatedOrganizationRoute: typeof AuthenticatedOrganizationRouteWithChildren
  AuthenticatedProjectsRoute: typeof AuthenticatedProjectsRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedGlobalRoute: AuthenticatedGlobalRouteWithChildren,
  AuthenticatedOrganizationRoute: AuthenticatedOrganizationRouteWithChildren,
  AuthenticatedProjectsRoute: AuthenticatedProjectsRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface BoardRouteChildren {
  BoardBoardBoardIdRoute: typeof BoardBoardBoardIdRoute
  BoardBoardIndexLazyRoute: typeof BoardBoardIndexLazyRoute
}

const BoardRouteChildren: BoardRouteChildren = {
  BoardBoardBoardIdRoute: BoardBoardBoardIdRoute,
  BoardBoardIndexLazyRoute: BoardBoardIndexLazyRoute,
}

const BoardRouteWithChildren = BoardRoute._addFileChildren(BoardRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  BoardRoute: BoardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
